var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.selectedPage)?_c('div',{attrs:{"id":"scoped-container"},domProps:{"innerHTML":_vm._s(_vm.selectedPage.htmlValue)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }